'use client';

import { c as _c } from "react/compiler-runtime";
import { ToastProvider as CommonToastProvider } from '@common/components';
import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';
import { findRoute } from '@/utils';
interface ToastProviderProps {
  children: ReactNode;
}
export const ToastProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const pathname = usePathname();
  const isTopToast = findRoute(pathname)?.toastDirection === "top";
  const positionClassName = isTopToast ? "!top-16" : "!bottom-[var(--toast-bottom)]";
  const t1 = isTopToast ? "top-center" : "bottom-center";
  let t2;
  if ($[0] !== positionClassName || $[1] !== t1) {
    t2 = <CommonToastProvider className={positionClassName} position={t1} />;
    $[0] = positionClassName;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <>{children}{t2}</>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};